<template>

  <div class="menu-title">
    <p>Bibimbap Dish</p>
  </div>


  <div class="bibimbap-container-1">

    <div class="bibimbap-grid-1">
      <div>
        <img class="menu-pic" src="../assets/BibimbapBeefBulgogi.jpg">
      </div>
      <div class="menu-text">
        <p>Beef Bulgogi Bibimbap</p>
      <!-- <p>12.99</p> -->
      </div>
    </div>

    <div class="bibimbap-grid-2">
      <div>
        <img class="menu-pic" src="../assets/BibimbapMushroom.jpg">
      </div>
      <div class="menu-text">
        <p>Mushroom Bibimbap</p>
      <!-- <p>11.99</p> -->
      </div>
    </div>

  </div>

</template>


<script>

  export default {
    name: 'BibimbapBody'
  }

</script>



<style scoped>

/* for desktop */
@media (min-width:701px) {

  .menu-title {
    text-align: center;
    font-size: 3vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-bottom: 5vw;
    color: darkblue;
  }

  .bibimbap-container-1 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    height: 28vw;
    margin-top: 0.5vw;
    background-color: rgb(250,250,250);
  }    
  
  .menu-pic {
    width: 22vw;
    height: 18vw;
    margin-top: 1vw;
    margin-left: 1.5vw;
  }

  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 2vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: -0.5vw;
  }

}


/* for Phone */
@media (max-width:700px) {

  .menu-title {
    text-align: center;
    font-size: 5vw;
    font-weight: bold;
    line-height: 2vw;
    margin-top: -1vw;
    color: darkblue;
  }

  .menu-pic {
    width: 15rem;
    height: auto;
    margin-top: 4vw
  }
  
  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 0.5rem;
    margin-bottom: 1vw
  }

}
  
</style>